export default {
  lightMode: false, // default to dark mode
  // TODO: inherit mode choice from the user such as below
  // !window.matchMedia("(prefers-color-scheme: light)").matches
  isFocusOnSearch: false,
}
